var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUnlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5629_8418)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.8423 2.88431C2.90912 1.76725 3.84993 0.89502 4.98798 0.89502H5.56261C6.69768 0.89502 7.63602 1.76496 7.70267 2.8791C7.72169 3.19687 7.4751 3.46963 7.15191 3.48832C6.82872 3.50701 6.55131 3.26455 6.5323 2.94678C6.50209 2.44195 6.07692 2.04778 5.56261 2.04778H4.98798C4.47069 2.04778 4.04305 2.44424 4.01267 2.95199L3.90382 4.77139C3.88482 5.08916 3.6074 5.33161 3.28421 5.31293C2.96103 5.29424 2.71444 5.02148 2.73345 4.7037L2.8423 2.88431Z",
    fill: "#0F172A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.69261 8.12558C1.73667 8.58392 2.10621 8.91154 2.56603 8.93557C3.13309 8.96521 4.03132 8.99615 5.31036 8.99615C6.5894 8.99615 7.48764 8.96521 8.05469 8.93557C8.51452 8.91154 8.88405 8.58392 8.92811 8.12558C8.96308 7.76183 8.99279 7.25947 8.99279 6.60257C8.99279 5.94566 8.96308 5.4433 8.92811 5.07955C8.88405 4.62121 8.51452 4.29359 8.05469 4.26956C7.48764 4.23992 6.5894 4.20898 5.31036 4.20898C4.03132 4.20898 3.13309 4.23992 2.56603 4.26956C2.10621 4.29359 1.73667 4.62121 1.69261 5.07955C1.65765 5.4433 1.62793 5.94566 1.62793 6.60257C1.62793 7.25947 1.65765 7.76183 1.69261 8.12558Z",
    fill: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.8536 7.05529C6.06002 7.04822 6.22278 6.90742 6.22935 6.70098C6.23031 6.6706 6.23086 6.63794 6.23086 6.60288C6.23086 6.56783 6.23031 6.53516 6.22935 6.50478C6.22278 6.29835 6.06002 6.15755 5.8536 6.15048C5.72239 6.14598 5.54536 6.14258 5.31026 6.14258C5.07515 6.14258 4.89812 6.14598 4.76691 6.15048C4.56049 6.15755 4.39773 6.29835 4.39116 6.50478C4.3902 6.53516 4.38965 6.56783 4.38965 6.60288C4.38965 6.63794 4.3902 6.6706 4.39116 6.70098C4.39773 6.90742 4.56049 7.04822 4.76691 7.05529C4.89812 7.05978 5.07515 7.06319 5.31026 7.06319C5.54536 7.06319 5.72239 7.05978 5.8536 7.05529Z",
    fill: "#0F172A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5629_8418"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.83784,
    height: 8.83784,
    fill: "white",
    transform: "translate(0.891602 0.526855)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlock);
export default __webpack_public_path__ + "static/media/unlock.b4e082291c87f903e0127546edb50153.svg";
export { ForwardRef as ReactComponent };